var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  fillRule: "nonzero",
  d: "m10.503 13.645 4.752-5.312 1.49 1.334-5.982 6.688-3.368-2.559 1.21-1.592z"
})));
export { SvgEmpty as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.5c043539.svg";